import React from 'react';
import { useTranslation } from 'react-i18next';
import { FiCheckCircle } from 'react-icons/fi';
import MetaData from '../../utils/MetaData'

function Terms() {
  const { t } = useTranslation();

  // Get terms and privacy content from the translation JSON
  const termsContent = t('terms', { returnObjects: true });
  const privacyContent = t('policy', { returnObjects: true });

  return (
    <>
      <MetaData
        title='Terms & Privacy | Be Alright Krabi'
        description='Read the terms and privacy policy for Be Alright Krabi, including booking, payments, cancellation policy, and user privacy details.'
        keywords='Be Alright Krabi terms, Krabi tour policy, privacy policy, booking terms'
        canonicalUrl={`${window.location.origin}/terms-privacy`}
        ogTitle='Terms & Privacy | Be Alright Krabi'
        ogDescription='Review terms, booking conditions, and privacy policy for Be Alright Krabi.'
        ogType='website'
        structuredData={{
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: 'Terms and Privacy',
          url: `${window.location.origin}/terms-privacy`
        }}
        structuredDataId='terms-jsonld'
      />
      <div className='mx-auto my-5 w-[94%] max-w-5xl'>
        <nav className="breadcrump" aria-label="breadcrumb">
          <ol className='flex flex-wrap items-center gap-2 text-sm text-slate-500'>
            <li><a href='/' className='font-medium text-slate-600 transition hover:text-[#1739bd]'>{t('sliderMenu.home')}</a></li>
            <li>/</li>
            <li className='font-semibold text-slate-700' aria-current='page'>{t('sliderMenu.termsPrivacy')}</li>
          </ol>
        </nav>
        <h1 className="text-center mb-4">{termsContent.title}</h1>

        {/* Render Terms and Conditions */}
        {Object.keys(termsContent).map((sectionKey) => {
          if (sectionKey === 'title') return null; // Skip the title key

          const section = termsContent[sectionKey];
          return (
            <div key={sectionKey} className="mb-4">
              <h3>{section.title}</h3>
              <ul className="list-unstyled">
                {section.points &&
                  section.points.map((point, index) => (
                    <li key={index} className="mb-2">
                      <FiCheckCircle className="mr-2 inline-block text-primary" />
                      {point}
                    </li>
                  ))}
              </ul>
            </div>
          );
        })}

        <h1 className="text-center my-5">{privacyContent.title}</h1>

        {/* Render Privacy Policy */}
        {Object.keys(privacyContent).map((sectionKey) => {
          if (sectionKey === 'title') return null; // Skip the title key

          const section = privacyContent[sectionKey];
          return (
            <div key={sectionKey} className="mb-4">
              <h3>{section.title}</h3>
              {Array.isArray(section.points) ? (
                <ul className="list-unstyled">
                  {section.points.map((point, index) => (
                    <li key={index} className="mb-2">
                      <FiCheckCircle className="mr-2 inline-block text-primary" />
                      {point}
                    </li>
                  ))}
                </ul>
              ) : (
                <p>{section.points}</p>
              )}
            </div>
          );
        })}
      </div>
    </>
  );
}

export default Terms;
